'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".SelectItem-module_selectItem__RCCdU{background-color:inherit;border:0;border-radius:4px;box-sizing:border-box;color:inherit;cursor:pointer;font-family:inherit;font-weight:inherit;padding:16px;text-align:left}.SelectItem-module_hoverBorder__gAB-p:hover{border-style:solid;border-width:1px}.SelectItem-module_noBorder__ssgK9{border:0}";
var styles = {"selectItem":"SelectItem-module_selectItem__RCCdU","hoverBorder":"SelectItem-module_hoverBorder__gAB-p","noBorder":"SelectItem-module_noBorder__ssgK9"};
styleInject["default"](css_248z, '66c9ed87-8b6e-4acb-98d6-cccc86607da4');

exports["default"] = styles;
